"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEventListener = addEventListener;
exports.debounce = debounce;
exports.keyDownEnter = keyDownEnter;
exports.strAddSuffix = strAddSuffix;
var _data = require("../data");
var _typeof = require("../data/typeof");
/**
 * 延迟执行函数，并返回取消计时器的方法
 * @param {*} fn 需要执行的函数
 * @param {*} wait 延迟时间
 * @param {*} immediate 是否立即执行
 */
function debounce(fn, wait, immediate) {
  var func = fn || _data.noop;
  var timeout;
  function debounceFunc() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var context = this;
    // https://fb.me/react-event-pooling
    if (args[0] && args[0].persist) {
      args[0].persist();
    }
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  }
  debounceFunc.cancel = function cancel() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounceFunc;
}
/**
 * 在 window 上绑定事件，并返回取消绑定的函数
 * @param  {...any} args
 */
function addEventListener() {
  var _window;
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  (_window = window).addEventListener.apply(_window, args);
  return function () {
    var _window2;
    (_window2 = window).removeEventListener.apply(_window2, args);
  };
}
/**
 * 在敲击 enter 键时执行 fn
 * @param {Event} e
 * @param {Function} fn
 */
function keyDownEnter(fn) {
  return function (e) {
    if (!e || !(0, _typeof.isObject)(e) || !(0, _typeof.isFunction)(fn)) return;
    if (e.keyCode === _data.KEYCODE.ENTER) {
      fn(e);
    }
  };
}
/**
 * 字符串空格前加后缀
 * @param {Event} e
 * @param {Function} fn
 */
function strAddSuffix(str, suffix) {
  if (str && suffix && str.trim() && str.trim().includes(' ')) {
    return str.trim().replace(/\s+/g, ' ').split(' ').map(function (item) {
      return item + suffix;
    }).join(' ');
  }
  if (str && suffix && str.trim() && !str.trim().includes(' ')) {
    return str.trim() + suffix;
  }
  return str;
}